import { useSyncExternalStore } from "react"

const FALLBACK_ORIGIN = "https://www.fuw.ch"

// Only trust FuW hosts, so third-party pages embedding the widget cannot keep
// visitors on their own domain.
function getReferrerOrigin(): string {
  try {
    const { origin, hostname } = new URL(document.referrer)
    if (hostname === "fuw.ch" || hostname.endsWith(".fuw.ch")) return origin
  } catch {
    // no or invalid referrer
  }
  return FALLBACK_ORIGIN
}

const subscribe = () => () => {}

/**
 * Origin of the page embedding this iframe, read from `document.referrer`,
 * so Börse links resolve against the host site instead of the embed origin.
 * Empty during SSR, falls back to the public website if no FuW referrer is sent.
 */
export function useBoerseWebsiteOrigin(): string {
  return useSyncExternalStore(subscribe, getReferrerOrigin, () => "")
}
